export default {
      id: "timer-usage",
      viewBox: "0 0 48 58",
      url: __webpack_public_path__ + "../../sprite.svg#timer-usage",
      toString: function () {
        return this.url;
      }
    }